import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "index",
  },
  {
    path: "/index",
    component: () => import("../views/Index"),
    children: [
      {
        path: "",
        name: "首页",
        component: () => import("../views/Main"),
      },

      {
        path: "/language",
        name: "文案",
        component: () => import("../views/Language"),
      },
      {
        path: "/clip",
        name: "音视频剪辑",
        component: () => import("../views/Clip"),
      },
      {
        path: "/map",
        name: "地图标记",
        component: () => import("../views/Map"),
      },
      {
        path: "/plan",
        name: "营销方案",
        component: () => import("../views/Plan"),
      },
    ],
  },
  {
    path: "/login",
    name: "登录",
    component: () => import("../views/Login"),
  },
  {
    path: "/forget",
    name: "修改密码",
    component: () => import("../views/Forget"),
  },
  {
    path: "/register",
    name: "注册用户",
    component: () => import("../views/Register"),
  },
  {
    path: "/document",
    name: "PDF修改",
    component: () => import("../views/Document"),
  },
  {
    path: "/profile",
    name: "个人中心",
    component: () => import("../views/Profile"),
  },
  {
    path: "/404",
    name: "页面错误",
    component: () => import("../views/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/**
 * 强制刷新浏览器地址栏
 */
router.afterEach((to, from) => {
  console.log("路由跳转:", from.path, "->", to.path);

  if (window.location.pathname !== to.path) {
    window.history.replaceState({}, "", to.fullPath);
  }
});

export default router;
